import React from "react";
import PinField, {
    Props as PinFieldProps,
} from "../../../../components/PinField/PinField";

import "./CodeInput.scss";

type CodeInputProps = {
    name: string;
    info?: string;
    isValid?: PinFieldProps["isValid"];
    fields?: PinFieldProps["fields"];
    onSubmit: PinFieldProps["onSubmit"];
    className?: string;
};
const CodeInput = ({
    name,
    isValid,
    info,
    fields,
    className,
    onSubmit,
}: CodeInputProps) => {
    return (
        <div className={`code-form ${className ?? ""}`}>
            <div className="code-form__form">
                <PinField
                    fields={fields}
                    name={name}
                    onSubmit={onSubmit}
                    inputStyle={{ ...defaultStyle, ...idleStyle }}
                    inputStyleInvalid={{ ...defaultStyle, ...errorStyle }}
                    isValid={isValid}
                />
                {info && <span>{info}</span>}
            </div>
        </div>
    );
};

export default CodeInput;

const defaultStyle = {
    width: "100%",
    height: `${80 / 16}rem`,
    fontSize: `${64 / 16}rem`,
    borderRadius: "4px",
    backgroundColor: "var(--white)",
    color: "inherit",
    border: "2px solid var(--dark-primary-blue)",
};
const idleStyle = {
    backgroundColor: "var(--white)",
};
const errorStyle = {
    backgroundColor: "rgb(185, 74, 72);",
};
